import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { PrivacyService } from '../privacy.service';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
    <div class="privacy-policy-container">
      <div class="privacy-policy-content">
        <button routerLink="/" class="btn btn-back-home">Retour à l'accueil Collary</button>
        <h1>Politique de Confidentialité</h1>
        
        <section>
          <h2>1. Introduction</h2>
          <p>Chez Collary, nous accordons une grande importance à la protection de vos données personnelles. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations.</p>
        </section>

        <section>
          <h2>2. Collecte des données</h2>
          <p>Nous collectons les informations suivantes :</p>
          <ul>
            <li>Informations d'identification (nom, prénom, email)</li>
            <li>Informations professionnelles (spécialité médicale, établissement)</li>
            <li>Données de connexion et d'utilisation</li>
            <li>Préférences et paramètres</li>
          </ul>
        </section>

        <section>
          <h2>3. Utilisation des données</h2>
          <p>Vos données sont utilisées pour :</p>
          <ul>
            <li>Gérer votre compte et vos missions</li>
            <li>Personnaliser votre expérience</li>
            <li>Améliorer nos services</li>
            <li>Communiquer avec vous</li>
            <li>Respecter nos obligations légales</li>
          </ul>
        </section>

        <section>
          <h2>4. Protection des données</h2>
          <p>Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos données :</p>
          <ul>
            <li>Chiffrement des données sensibles</li>
            <li>Accès restreint aux données</li>
            <li>Surveillance régulière de nos systèmes</li>
            <li>Formation de notre personnel</li>
          </ul>
        </section>

        <section>
          <h2>5. Vos droits</h2>
          <p>Conformément au RGPD, vous disposez des droits suivants :</p>
          <ul>
            <li>Droit d'accès à vos données</li>
            <li>Droit de rectification</li>
            <li>Droit à l'effacement</li>
            <li>Droit à la portabilité</li>
            <li>Droit d'opposition</li>
            <li>Droit de limitation du traitement</li>
          </ul>
        </section>

        <section>
          <h2>6. Cookies et technologies similaires</h2>
          <p>Nous utilisons différents types de cookies :</p>
          <ul>
            <li><strong>Cookies essentiels :</strong> Nécessaires au fonctionnement du site</li>
            <li><strong>Cookies de préférences :</strong> Pour mémoriser vos paramètres</li>
            <li><strong>Cookies analytiques :</strong> Pour améliorer nos services</li>
            <li><strong>Cookies marketing :</strong> Pour personnaliser votre expérience</li>
          </ul>
        </section>

        <section>
          <h2>7. Gestion de vos données</h2>
          <div class="data-management">
            <button (click)="exportData()" class="btn btn-primary">Exporter mes données</button>
            <button (click)="deleteData()" class="btn btn-danger">Supprimer mes données</button>
          </div>
        </section>

        <section>
          <h2>8. Contact</h2>
          <p>Pour toute question concernant vos données personnelles, contactez-nous :</p>
          <p>Email : privacy&#64;collary.com</p>
          <p>Adresse : 123 Rue de la Santé, 75000 Paris, France</p>
        </section>

        <section>
          <h2>9. Mises à jour</h2>
          <p>Cette politique de confidentialité peut être mise à jour périodiquement. La dernière mise à jour date du {{lastUpdate | date:'dd/MM/yyyy'}}.</p>
        </section>
      </div>
    </div>
  `,
  styles: [`
    .privacy-policy-container {
      max-width: 80vw;
      margin: 2rem auto;
      padding: 0 1rem;
    }

    .privacy-policy-content {
      background: white;
      padding: 2rem;
      border-radius: 8px;
    }

    .btn-back-home {
      margin-bottom: 20px;
      padding: 10px 15px;
      background-color: #f0f0f0;
      border: 1px solid #ccc;
      color: #333;
      cursor: pointer;
      border-radius: 4px;
      text-decoration: none; /* Remove underline from routerLink */
      display: inline-block; /* Allow padding/margin */
    }

    .btn-back-home:hover {
      background-color: #e0e0e0;
    }

    h1 {
      text-align: center;
      color: #333;
      margin-bottom: 2rem;
      font-size: 2rem;
    }

    section {
      margin-bottom: 2rem;
    }

    h2 {
      color: #444;
      margin-bottom: 1rem;
      font-size: 1.5rem;
    }

    p {
      line-height: 1.6;
      color: #666;
      margin-bottom: 1rem;
    }

    ul {
      list-style-type: disc;
      margin-left: 1.5rem;
      margin-bottom: 1rem;
    }

    li {
      margin-bottom: 0.5rem;
      color: #666;
    }

    .data-management {
      display: flex;
      gap: 1rem;
      margin-top: 1rem;
    }

    .btn {
      padding: 0.75rem 1.5rem;
      border-radius: 4px;
      cursor: pointer;
      border: none;
      font-weight: 500;
      transition: background-color 0.3s;
    }

    .btn-primary {
      background: #007bff;
      color: white;
    }

    .btn-primary:hover {
      background: #0056b3;
    }

    .btn-danger {
      background: #dc3545;
      color: white;
    }

    .btn-danger:hover {
      background: #c82333;
    }

    @media (max-width: 768px) {
      .privacy-policy-content {
        padding: 1rem;
      }

      .data-management {
        flex-direction: column;
      }

      .btn {
        width: 100%;
      }
    }
  `]
})
export class PrivacyPolicyComponent {
  lastUpdate = new Date('2024-03-20');

  constructor(private privacyService: PrivacyService) {}

  exportData() {
    const data = this.privacyService.exportUserData();
    const blob = new Blob([data], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'mes-donnees-collary.json';
    a.click();
    window.URL.revokeObjectURL(url);
  }

  deleteData() {
    if (confirm('Êtes-vous sûr de vouloir supprimer toutes vos données ? Cette action est irréversible.')) {
      this.privacyService.deleteUserData();
      alert('Vos données ont été supprimées avec succès.');
    }
  }
} 